<template>
   <p>
      Step 1: Install the ezbot tracker on your website. This small piece of
      code will help ezbot understand how visitors use your website. It
      automatically tracks page views, clicks, and other important activities
      without you having to do anything else.
      <a href="https://docs.ezbot.ai/get-started/install/" target="_blank"
         >Need more details? Check our installation guide.</a
      >
   </p>
   <p>
      If you use Google Tag Manager (GTM) on your website:
      <a
         href="https://docs.ezbot.ai/guides/installation/google-tag-manager/"
         target="_blank"
         >Follow our easy Google Tag Manager guide instead.</a
      >
   </p>
   <VCodeBlock
      :code="htmlCode"
      highlightjs
      label="For manual installation, ask your web developer to add this code to your website:"
      lang="html"
      theme="github-dark-dimmed"
      copy-button
      :persistent-copy-button="true"
   />
</template>
<script lang="ts" setup>
import { useProjectStore } from "@stores/projectStore"
import { ref } from "vue"
import VCodeBlock from "@wdns/vue-code-block"
const htmlCode = ref<string>("")
const projectStore = useProjectStore()
htmlCode.value = `
<!-- This is the ezbot tracker code - paste it at the bottom of your website's HTML, just before the closing </body> tag -->
<script src="https://cdn.ezbot.ai/web-snippets/ezbot.min.js"><\/script>
<script>
  document.addEventListener('DOMContentLoaded', function() {
    ezbot.initEzbot(${projectStore.projectId})
      .then(function() {
        ezbot.startActivityTracking({
          minimumVisitLength: 10,
          heartbeatDelay: 10
        });
        ezbot.trackPageView();
        ezbot.makeVisualChanges();
      })
      .catch(function(error) {
        console.error('Failed to initialize Ezbot:', error);
      });
  });
<\/script>`
</script>
